<nav class="navbar navbar-expand-lg navbar-light bg-faded fixed-top">
    <div class="navbar-header">
        <a class="navbar-brand" href="{{officeUrl()}}">
            <span>
                <img src="assets/images/bayclub-white.png" alt="Bay Club" />
            </span>
            <span class="navbar-brand-name hidden-sm hidden-xs">Camps</span>
        </a>
    </div>

    <div class="collapse navbar-collapse" id="navbarNav">
        <!-- <span  [showIfPrivileges]="'Camps.campsCanView'">
            <ul class="navbar-nav">
                <li class="nav-item active">
                    <a class="nav-link" href="#">Dashboard
                        <span class="sr-only">(current)</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#/purchases">Enrollment</a>
                </li>
                 <li class="nav-item">
                    <a class="nav-link" href="#/camps">Camps management</a>
                </li> 
            </ul>
        </span> -->
    </div>

    <app-logged-user></app-logged-user>

</nav>